module.exports = __webpack_public_path__ + "static/img/bottom-ac-bg.b072e35a.png";